module.exports = __webpack_public_path__ + "img/pick_5.edff0b9c.png";